import React from 'react';
import { motion } from 'framer-motion';
export function ArticleHeader() {
  return <motion.header initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.8,
    ease: 'easeOut'
  }} className="max-w-2xl mx-auto px-4 pt-12 pb-8" data-id="element-33">
      <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 leading-[1.15] mb-8 text-balance" data-id="element-34">
        Dermatóloga Revela Por Qué Tu Piel Envejece Más Rápido Después de los 40{' '}
        <span className="text-burgundy italic font-normal" data-id="element-35">
          (Y El Método Japonés Que Lo Revierte en 16 Días)
        </span>
      </h1>

      <div className="flex items-center gap-4 border-t border-b border-gold/20 py-4" data-id="element-36">
        <img src="https://images.unsplash.com/photo-1559839734-2b71ea197ec2?q=80&w=200&auto=format&fit=crop" alt="Dra. María Rodríguez" className="w-12 h-12 rounded-full object-cover border border-gold/40" data-id="element-37" />
        <div className="flex flex-col" data-id="element-38">
          <span className="font-sans font-medium text-sm text-gray-900" data-id="element-39">
            Por Dra. María Rodríguez
          </span>
          <span className="font-sans text-xs text-gray-500" data-id="element-40">
            Especialista en Medicina Estética • 15 de Marzo, 2025
          </span>
        </div>
      </div>
    </motion.header>;
}